"use strict";

export default class Session {

	/**
     * Set session key / value pair.
     * @param {String} key
     * @param {Object|String|Number} value
     * @return
     */
	static set(key, value)
	{
		if (typeof value === "object") {
			sessionStorage.setItem(key, JSON.stringify(value));
		} else {
			sessionStorage.setItem(key, value);
		}
	}

	/**
     * Get value from session storage
     * @param {String} key
     * @return {null|Object|String|Number}
     */
	static get(key)
	{
		let value = sessionStorage.getItem(key);

		if (value && value.startsWith("{")) {
			try {
				return JSON.parse(value);
			} catch (error) {
			}
		}
		return value;
	}

	/**
     * Remove key / value pair from session
     * @param {String} key
     * @return
     */
	static remove(key)
	{
		sessionStorage.removeItem(key);
	}

}
